import * as React from "react";
import { cn } from "../lib/cn";

/** Keyboard-shortcut chip. Base look lives in base.css `kbd`; this adds
 * layout and lets callers pass sequences like <Kbd>g i</Kbd>. */
export function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "inline-flex min-w-5 items-center justify-center gap-1",
        className,
      )}
      {...props}
    />
  );
}
